<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	import {
		companyPath,
		myCompanyApplys,
		getUserCompany
	} from '@/api'
	import s from "./config/sj.js"
	export default {
		onLaunch: function() {
			console.log('App onLaunch')
			// 如果是微信，缓存令牌，this.$wechat.isWechat() == 'isWechat'表示在微信或者微信浏览器H5
			// window.navigator.userAgent.toLowerCase().match(/micromessenger/i) == 'micromessenger'表示在非微信浏览器中的H5
			if (this.$wechat.isWechat() == 'isWechat') {
				console.log(this.$wechat.isWechat())
				uni.setStorageSync('lang', this.getparams().lang)
				uni.setStorageSync('access_token', this.getparams().access_token)
				uni.setStorageSync('refresh_token', this.getparams().refresh_token)
				uni.setStorageSync('token_access_token_exprie', this.getparams().token_access_token_exprie)
				//获取企业信息
				uni.request({
					url: window.config.apiPath+'/amc/api/token/user/getUserCompany',
					data: {},
					header:{
						"Authorization": 'Bearer ' + this.getparams().access_token
					},
					success: (res) => {
						if (res && res.data.success) {
							uni.setStorageSync("all_company", res.data.data);
							let company=this.getparams().company
							let curCompany=res.data.data.filter((item)=>{
								return item.id==company
							})[0]
							uni.setStorageSync('curCompany', curCompany)
							
						}
					}
				});
				// 初始化扫码
				this.$wechat.initJssdk()
			}
			this.$wechat.initJssdk()
		},
		onShow: function() {
			console.log('App onshow')
			this.getBtnJurisdiction()
		},
		onHide: function() {
			console.log('App Hide')
		},
		methods: {
			UrlSearch() {
				var name, value;
				var str = location.href; //取得整个地址栏
				var num = str.indexOf("?")
				str = str.substr(num + 1); //取得所有参数 stringvar.substr(start [, length ]
				var arr = str.split("&"); //各个参数放到数组里
				for (var i = 0; i < arr.length; i++) {
					num = arr[i].indexOf("=");
					if (num > 0) {
						name = arr[i].substring(0, num);
						value = arr[i].substr(num + 1);
						this[name] = value;
					}
				}
			},
			getparams() {
				var name, value;
				var str = location.href; //取得整个地址栏
				var num = str.indexOf("?")
				str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]
				let obj = {}
				var arr = str.split("&"); //各个参数放到数组里
				for (var i = 0; i < arr.length; i++) {
					num = arr[i].indexOf("=");
					if (num > 0) {
						name = arr[i].substring(0, num);
						value = arr[i].substr(num + 1);
						obj[name] = value;
					}
				}
				return obj
			},
			getBtnJurisdiction() {
				console.log('获取按钮权限')
				myCompanyApplys({}, data => {
					if (data && data.success) {
						let btnUrlList = []
						for (var i = 0; i < data.data.length; i++) {
							var m = data.data[i];
							if (m.menuType == 2) { //按钮
								btnUrlList.push(m.method + '^' + m.url);
							}
						}
						uni.setStorageSync('btnUrl', btnUrlList)
					}
				});
			},
		}
	}
</script>

<style lang="scss">
	/* 注意要写在第一行，同时给style标签加入lang="scss"属性 */
	@import "@/uni_modules/uview-ui/index.scss";
	/*每个页面公共css */
	@import '@/uni_modules/uni-scss/index.scss';
	// 全局公共样式变量
	@import '@/static/style/sj.css';
	/* #ifndef APP-NVUE */
	@import '@/static/customicons.css';

	// 设置整个项目的背景色
	page {
		background-color: #f5f5f5;
	}

	/* #endif */
	.example-info {
		font-size: 14px;
		color: #333;
		padding: 10px;
	}

	.ellipsis {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	
</style>